"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// do to the backend sending non-supported instruements in an undesirably ordered fashion
// we have to do the filtering and sorting on the front end
var filterSortSupportedInstruments = function filterSortSupportedInstruments(itemsArray) {
  if (!_config["default"].global.instruments || _config["default"].global.instruments.length === 0) {
    return itemsArray;
  }
  var filteredSortedInstruments = [];
  _config["default"].global.instruments.forEach(function (symbol) {
    var instrument = itemsArray.find(function (item) {
      return item.Symbol === symbol;
    });
    if (instrument) {
      filteredSortedInstruments.push(instrument);
    }
  });
  return filteredSortedInstruments;
};
var _default = exports["default"] = filterSortSupportedInstruments;